import './ZoneSelectionModal.scss';

import { Button, Modal, Stack } from 'react-bootstrap';

import { IQueryExportCountModel } from '../../../utilities/Constants';
import { useAuthContext } from '../../../contexts/AuthContext';

export interface IZoneSelectionModalProps {
    counts: IQueryExportCountModel[];
    onCancel: () => void;
    onClose: () => void;
    onSubmit: (zoneGuid: string) => void;
    zoneGuids: string[];
    open: boolean;
}

export function ZoneSelectionModal(props: IZoneSelectionModalProps) {
    const { user } = useAuthContext();

    const handleZoneSelectionClick = (zoneGuid: string) => {
        props.onSubmit(zoneGuid);
    };

    const orgCountsSorted = props.counts
        .filter((c) => user.organizationRoles?.map((or) => or.guid).includes(c.orgId))
        .map((c) => {
            const found = user.organizationRoles?.find((or) => or.guid === c.orgId);

            return {
                ...c,
                shortName: found?.shortName,
                guid: found?.guid,
            };
        })
        .sort((a, b) =>
            (a.shortName?.toLowerCase() ?? '') < (b.shortName?.toLowerCase() ?? '') ? -1 : 1
        );

    return (
        <Modal centered show={props.open} backdrop>
            <Modal.Header>
                <Modal.Title>Select a Zone</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Stack gap={3}>
                    <div>
                        Multiple zones have documents ready to view.
                        <br />
                        Select the zone you would like to view documents for:
                    </div>
                    <ul className="mx-2">
                        {orgCountsSorted.map((countWithName) => {
                            return (
                                <li
                                    className="zone-list-item"
                                    onClick={() => handleZoneSelectionClick(countWithName.guid!)}
                                    key={countWithName.guid}
                                >
                                    <Stack
                                        direction="horizontal"
                                        gap={2}
                                        style={{ alignItems: 'center' }}
                                    >
                                        <span className="org-name">{countWithName.shortName}</span>
                                        <span className="count text-gray">({countWithName.count} unread)</span>
                                        {/* <Badge
                                            pill
                                            bg="secondary"
                                            title="Number of unread documents"
                                        >
                                            {countWithName.count}
                                        </Badge> */}
                                    </Stack>
                                </li>
                            );
                        })}
                    </ul>
                </Stack>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="dark" onClick={props.onCancel}>
                    OK
                </Button>
            </Modal.Footer>
        </Modal>
    );
}
